import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  home: {
    display: 'flex',
    justifyContent: 'space-evenly',
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '579px',
  },
}))

export default useStyles
